export default __webpack_public_path__ + "static/media/BrainBreak cards75.92ee2e4c.png";